var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterialSymbolsHomeOutlineRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 310,
    viewBox: "0 0 307 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.75 245.417H115.125V167.917H191.875V245.417H230.25V129.167L153.5 71.0417L76.75 129.167V245.417ZM76.75 271.25C69.7146 271.25 63.6897 268.718 58.6754 263.655C53.661 258.592 51.1581 252.512 51.1666 245.417V129.167C51.1666 125.076 52.0749 121.201 53.8913 117.542C55.7077 113.882 58.2106 110.868 61.4 108.5L138.15 50.375C140.495 48.6528 142.947 47.3612 145.505 46.5C148.064 45.6389 150.728 45.2084 153.5 45.2084C156.272 45.2084 158.936 45.6389 161.495 46.5C164.053 47.3612 166.505 48.6528 168.85 50.375L245.6 108.5C248.798 110.868 251.305 113.882 253.121 117.542C254.938 121.201 255.842 125.076 255.833 129.167V245.417C255.833 252.521 253.326 258.605 248.312 263.668C243.297 268.731 237.277 271.259 230.25 271.25H166.292V193.75H140.708V271.25H76.75Z",
    fill: "#BA8108"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsHomeOutlineRounded);
export default __webpack_public_path__ + "static/media/material-symbols_home-outline-rounded.7565f9e070993821b9cfd1d12e820d4f.svg";
export { ForwardRef as ReactComponent };